import { render, staticRenderFns } from "./DebugList.vue?vue&type=template&id=5b31848c"
import script from "./DebugList.vue?vue&type=script&lang=ts"
export * from "./DebugList.vue?vue&type=script&lang=ts"
import style0 from "./DebugList.vue?vue&type=style&index=0&id=5b31848c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports